// test1102
(1102 && 0);
